<template>
  <div class="ctrl-affiliate-rewards-user-summaries">
    <el-row type="flex" justify="center" align="middle">
      <el-col :span="8" style="text-align: center">
        <span>振込月: </span>
        <el-date-picker
          v-model="transferMonth"
          type="month"
          format="yyyy年MM月"
          value-format="yyyyMM01"
          placeholder="月を選択"
        />
      </el-col>
      <el-col :span="4" v-loading="loading" style="text-align: center">
        <el-button @click="downloadBankCsv" type="primary"
          >ダウンロード</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CtrlAffiliateDownloadBankCsvDownloadBankCsv",
  components: {},
  props: {},
  data() {
    return {
      loading: false,
      transferMonth: "",
    };
  },
  computed: {
    ...mapGetters(["rt", "apiErrorMessage"]),
  },
  watch: {},
  methods: {
    downloadBankCsv() {
      if (this.transferMonth !== "") {
        //ok.
      } else {
        alert("月を選択してください。");
        return;
      }
      this.loading = true;
      let params = new URLSearchParams();
      params.append("transfer_month", this.transferMonth);
      this.$axios
        .get(`${this.rt}/l/api/affiliate/download-bank-csv`, { params })
        .then((response) => {
          console.log(response);

          // CheckCtrlUserId は未移行 (HTTP 200 + 本文 status:401) なので本文を見る
          if (response.data.status !== 401) {
            location.href = `${this.rt}/l/api/file/download`;
            this.loading = false;
            return;
          } else {
            alert(response.data.message);
            this.$router.push("/login");
            return;
          }
        })
        .catch((error) => {
          console.log(error);

          //
          let message = this.apiErrorMessage;
          if (error.response !== undefined && error.response.data.message !== undefined) {
            message = error.response.data.message;
          } else {
            // no action.
          }
          alert(message);
          this.loading = false;
          return;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
